export default __webpack_public_path__ + "static/media/richard_di_natale.e6e7a88f.jpg";